module.exports = __webpack_public_path__ + "img/_HappyLuckyCharm.7849ff34.png";